import { render, staticRenderFns } from "./ExterMesaPartesVirtual.vue?vue&type=template&id=4ab075ba&scoped=true"
import script from "./ExterMesaPartesVirtual.vue?vue&type=script&lang=js"
export * from "./ExterMesaPartesVirtual.vue?vue&type=script&lang=js"
import style0 from "./ExterMesaPartesVirtual.vue?vue&type=style&index=0&id=4ab075ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab075ba",
  null
  
)

export default component.exports